module.exports = __webpack_public_path__ + "img/juanzhou.0bd3f568.png";